import request from '../../utils/request';

export function getAuthorList(params) {
  return request({
    url: 'users',
    type: 'get',
    params,
  });
}

export function getAuthorDetail(id) {
  return request({
    url: `users/${id}`,
    type: 'get',
  });
}

export function getAuthorWallet(serial_number) {
  return request({
    url: `company-center/reports/wallet/${serial_number}`,
    type: 'get',
  });
}
